import { useEffect } from 'react';
import { Client } from '../helpers/client/client.esm.js';

function setupCsrf(csrf) {
    Client.getAxiosInstance().defaults.headers.common["X-CSRF-Token"] = csrf; // eslint-disable-line @typescript-eslint/no-unsafe-member-access
}
var useSetupCsrf = function(param) {
    var csrf = param.csrf;
    useEffect(function() {
        setupCsrf(csrf);
    }, [
        csrf
    ]);
};

export { setupCsrf, useSetupCsrf };
